<section [style.padding-left]="'16.002px'" [style.padding-right]="'16.002px'">
  <div class="bg-white px-5 py-6 border-round-2xl box-shadow">
    <form [formGroup]="form" class="w-full">
      <div class="flex justify-content-between" *ngIf="filterBySplit">
        <div [style.width]="'auto'">
          <p-selectButton [options]="[
              { label: 'Mês a mês', value: 'moth-to-month' },
              { label: 'Anual', value: 'yearly' }
            ]" (onOptionClick)="onOptionClick($event)" optionLabel="label" optionValue="value" [allowEmpty]="false"
            formControlName="selectButtonFrequency"></p-selectButton>
        </div>
        <div [style.width]="'25%'">
          <span class="p-float-label">
            <p-dropdown [options]="monthOptions" [autoDisplayFirst]="false" placeholder="Data" optionLabel="label"
              optionValue="value" formControlName="dropdownPeriod" (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Data</label>
          </span>
          </div>
        <div [style.width]="'25%'">
          <span class="p-float-label">
            <p-dropdown [options]="unitOptions" [showClear]="true" [autoDisplayFirst]="false" placeholder="Unidade" optionLabel="unitName"
              optionValue="id" formControlName="dropdownUnit" (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Unidade</label>
          </span>
        </div>
        <div [style.width]="'25%'">
          <span class="p-float-label">
            <p-dropdown [options]="[
                        { label: 'Sim', value: 'true' },
                        { label: 'Não', value: 'false' },
                        { label: 'Todos', value: 'all' }
                      ]" [autoDisplayFirst]="false" placeholder="Split" optionLabel="label" optionValue="value"
              formControlName="dropdownSplit" (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Split</label>
          </span>
        </div>
      </div>
  
      <div class="flex justify-content-between" *ngIf="!filterBySplit && !filterByAddress">
        <div [style.width]="'auto'">
          <p-selectButton [options]="[
              { label: 'Mês a mês', value: 'moth-to-month' },
              { label: 'Trimestral', value: 'quarterly' },
              { label: 'Anual', value: 'yearly' }
            ]" (onOptionClick)="onOptionClick($event)" optionLabel="label" optionValue="value" [allowEmpty]="false"
            formControlName="selectButtonFrequency"></p-selectButton>
        </div>
        <div [style.width]="'33%'">
          <span class="p-float-label">
            <p-dropdown [options]="monthOptions" [autoDisplayFirst]="false" placeholder="Data" optionLabel="label"
              optionValue="value" formControlName="dropdownPeriod" (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Data</label>
          </span>
        </div>
        <div [style.width]="'33%'">
          <span class="p-float-label">
            <p-dropdown [options]="(unitsFromAPI$ | async)!" [autoDisplayFirst]="false" placeholder="Unidade"
              optionLabel="unitName" optionValue="id" formControlName="dropdownUnit"
              (onChange)="addNewFilterEvent()"></p-dropdown>
            <label for="float-label" class="text-base">Unidade</label>
          </span>
        </div>
      </div>
  
      <div class="flex justify-content-between" *ngIf="filterByAddress">
        
        <div [style.width]="'auto'" >
          <p-selectButton class="w-full" [options]="[
              { label: 'Mês a mês', value: 'mes a mes' },
              { label: 'Anual', value: 'anual' }
            ]" (onOptionClick)="onOptionClick($event)" optionLabel="label" optionValue="value" [allowEmpty]="false"
            formControlName="selectButtonFrequency"></p-selectButton>
        </div>
        <div [style.width]="'39%'">
          <p-dropdown class="w-full" [options]="monthOptions" [autoDisplayFirst]="false" placeholder="Data" optionLabel="label"
            optionValue="value" formControlName="dropdownPeriod" (onChange)="addNewFilterEvent()"></p-dropdown>
        </div>
        <div [style.width]="'39%'">
          <p-dropdown class="w-full" [options]="address" [autoDisplayFirst]="false" placeholder="Todos os endereços" optionLabel="label"
            optionValue="value" formControlName="dropdownAddress" (onChange)="addNewFilterEvent()"></p-dropdown>
        </div>
  
      </div>
    </form>
  </div>
</section>